import { Mail, Phone } from "lucide-react";
import logoBlack from "@/assets/logo-black.png";

const Footer = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <footer className="bg-card border-t border-border">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo e Descrição */}
          <div>
          <img 
            src={logoBlack} 
            alt="Digital Ideia - Soluções Tecnológicas Inteligentes" 
            className="h-10 w-auto object-contain mb-4"
            width="180"
            height="40"
          />
            <p className="text-muted-foreground mb-4">
              Transformamos ideias em soluções digitais inteligentes.
            </p>
          </div>

          {/* Links Rápidos */}
          <div>
            <h3 className="font-semibold mb-4">Links Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection("home")} className="text-muted-foreground hover:text-primary transition-colors">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection("about")} className="text-muted-foreground hover:text-primary transition-colors">
                  Sobre Nós
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection("services")} className="text-muted-foreground hover:text-primary transition-colors">
                  Serviços
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection("portfolio")} className="text-muted-foreground hover:text-primary transition-colors">
                  Portfólio
                </button>
              </li>
            </ul>
          </div>

          {/* Serviços */}
          <div>
            <h3 className="font-semibold mb-4">Serviços</h3>
            <ul className="space-y-2 text-muted-foreground">
              <li>Desenvolvimento de Sistemas</li>
              <li>Aplicativos Mobile</li>
              <li>Sites e E-commerce</li>
              <li>Inteligência Artificial</li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h3 className="font-semibold mb-4">Contato</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-muted-foreground">
                <Mail size={18} className="mt-1 flex-shrink-0" />
                <span>contato@digitalideia.com.br</span>
              </li>
              <li className="flex items-start gap-2 text-muted-foreground">
                <Phone size={18} className="mt-1 flex-shrink-0" />
                <span>044 2018-1162</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8 text-center text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} Digital Ideia. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
